

import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
} from "@mui/material";

const ViewApplicantModal = ({ open, onClose, applicant }) => {
  if (!applicant) return null;

  const renderField = (label, value) => (
    <Grid item xs={12} sm={6}>
      <Typography variant="subtitle2">{label}</Typography>
      <Typography variant="body1" gutterBottom>
        {value || "—"}
      </Typography>
    </Grid>
  );

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>👤 Datos del Aspirante</DialogTitle>
      <DialogContent dividers>
        <Typography variant="h6" gutterBottom>
          Información Personal y Profesional
        </Typography>
        <Grid container spacing={2}>
          {renderField("Nombre", applicant.nombre)}
          {renderField("Apellido", applicant.apellido)}
          {renderField("País", applicant.country)}
          {renderField("Género", applicant.genero)}
          {renderField("Fecha de nacimiento", applicant.birth_date)}
          {renderField("Número de Documento", applicant.numero_documento)}
          {renderField("Teléfono Móvil", applicant.telefono_movil)}
          {renderField("Teléfono Trabajo", applicant.telefono_trabajo)}
          {renderField("Dirección", applicant.direccion)}
          {renderField("Profesión", applicant.profesion)}
          {renderField("Título Profesional", applicant.titulo_profesional)}
          {renderField("Especialidad", applicant.especialidad)}
          {renderField("Institución de Especialidad", applicant.institucion_especialidad)}
          {renderField("Institución Laboral Actual", applicant.institucion_laboral_actual)}
          {renderField("Otras Asociaciones", applicant.otras_asociaciones)}
          {renderField("CV (enlace)", <a href={applicant.cvLink} target="_blank" rel="noopener noreferrer">{applicant.cvLink}</a>)}        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewApplicantModal;